import "vuetify/styles";
import "@socotec.io/socio-vue-components/style.css";
import "@socotec.io/socio-vue-components/components-style";
import { createVuetify } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import i18n from "@/setup/i18n";
import { useI18n } from "vue-i18n";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import merge from "lodash/merge";

export default createVuetify(
  merge({}, socioVuetifyConfig, {
    defaults: {
      VSelect: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VTextField: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VCheckbox: { density: "compact" },
      VAutocomplete: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VNumberInput: {
        controlVariant: "stacked",
        variant: "outlined",
        density: "compact",
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
  }),
);
